<template>
  <div class="container">
    <div class="loading" v-if="fetchData">
      <load-data></load-data>
    </div>
    <div v-if="!fetchData">

      <b-modal id="cancelDeletePoConfirmationModel" hide-header-close hide-footer hide-header centered size="sm">
        <h6 style="font-size: 18px; font-weight: 600" class="text-danger">
          Are you sure you want to proceed
        </h6>
        <div>
          <b-form-group id="input-group-1" label-for="input-1">
            <label class="required-label" for="">Enter a brief explanation of the reason for cancellation of
              deletion (Minimum 10 character):</label>
            <b-form-input id="input-1" v-model="deletePoModel.reason" type="text"
              placeholder="Enter Reason"></b-form-input>
          </b-form-group>
        </div>
        <div class="buttons">
          <b-button :disabled="(deletePoModel.reason.length < 10)" size="sm" variant="primary"
            @click="CancelDeletion()">Cancel Deletion</b-button>
          <b-button size="sm" variant="danger" class="ml-2"
            @click="$bvModal.hide('cancelDeletePoConfirmationModel')">Cancel</b-button>
        </div>
      </b-modal>

      <b-modal id="deletePoConfirmationModel" hide-header-close hide-footer hide-header centered size="sm">
        <h6 style="font-size: 18px; font-weight: 600" class="text-danger">
          Are you sure you want to delete {{ deletePoModel.name }}
        </h6>
        <div :class="['disable-wrapper', { disabled: showOtpBox }]">
          <div>
            <b-form-group id="input-group-1" label-for="input-1">
              <label class="required-label" for="">Type 'DELETE' and press delete button to complete deletion:</label>
              <b-form-input id="input-1" v-model="deletePoModel.confirmText" type="text" placeholder="Enter  DELETE"
                :class="['disable-wrapper', { disabled: showOtpBox }]"></b-form-input>
            </b-form-group>
          </div>
          <div>
            <b-form-group id="input-group-1" label-for="input-1">
              <label class="required-label" for="">Enter a brief explanation of the reason for deletion (Minimum 10
                character):</label>
              <b-form-input id="input-1" v-model="deletePoModel.reason" type="text" placeholder="Enter Reason"
                :class="['disable-wrapper', { disabled: showOtpBox }]"></b-form-input>
            </b-form-group>
          </div>
          <div class="buttons">
            <b-button :disabled="(deletePoModel.confirmText != 'DELETE' || deletePoModel.reason.length < 10)" size="sm"
              variant="primary" @click="sendOtp()">Delete</b-button>
            <b-button size="sm" variant="danger" class="ml-2"
              @click="$bvModal.hide('deletePoConfirmationModel'); otp = null; showOtpBox = false;">Cancel</b-button>
          </div>
        </div>
        <div v-if="showOtpBox" class="mt-3">
          <b-form-group>
            <label class="required-label">Enter OTP to confirm deletion:</label>
            <b-form-input v-model="otp" placeholder="Enter OTP"></b-form-input>
          </b-form-group>

          <p class="text-danger small">Please contact ezygo support for OTP</p>

          <div class="d-flex align-items-center mt-2">
            <b-button variant="success" size="sm" @click="verifyOtp()">
              Verify OTP & DELETE
            </b-button>

            <b-button size="sm" variant="danger" class="ml-2"
              @click="$bvModal.hide('deletePoConfirmationModel'); otp = null; showOtpBox = false;">
              Cancel
            </b-button>
          </div>


        </div>

      </b-modal>

      <b-row class="control-buttons">
        <b-col v-if="resourceaction == 'list' && !course_id" style="text-align:left;">
          <b-button variant="success" class="text-white sm" size="sm" @click="createEditPo(null)">Add
            PO</b-button>
          <!-- <b-button variant="success" class="ml-2 text-white sm" size="sm" @click="downloadPdf()">Download
            PDF</b-button> -->
        </b-col>
        <b-col v-if="(resourceaction == 'createEdit' && po.id == null && !enableImport && !enablePoCopy)"
          style="text-align:left;">
          <b-row>
            <b-button variant="success" class="mr-2 text-white sm" size="sm" @click="(enableImport = true)">Import
              Excel</b-button>
            <b-button variant="success" class="mr-2 text-white sm" size="sm" @click="getCopyPoOptions">Copy
              From Other Programmes </b-button>
          </b-row>
        </b-col>
        <b-col v-if="resourceaction != 'list'" style="text-align:right;">
          <b-button
            variant="success"
            class="text-white sm mr-2"
            size="sm"
            @click="createUpdatePo"
            :disabled="actionButton.disabled"
          >
            {{ actionButton.text }}
          </b-button>

          <b-button
            variant="danger"
            class="text-white sm"
            size="sm"
            @click="resourceaction = 'list'"
            :disabled="actionButton.disabled"
          >
            Cancel
          </b-button>
        </b-col>

      </b-row>
      <div v-if="resourceaction == 'list'">
        <h3 style="text-align: center; font-size:18px !important;">
          Programme Outcomes
        </h3>
        <b-row>
          <b-col sm="12">
            <div class="table-responsive rounded">
              <table class="table table-striped table-bordered">
                <thead class="thead-dark text-left">
                  <tr>
                    <th>
                      SI. No.
                    </th>
                    <th>
                      Code
                    </th>
                    <th>
                      Outcome
                    </th>
                    <th v-if="!course_id"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(po, reindex) in pos" :key="reindex">
                    <td>{{ po.si_no }}</td>
                    <td>
                      {{ po.code }}
                      <div v-if="(po.deleted_at != null)">
                        <vue-countdown :time="timeToDeleteIn(po.deleted_at)" v-slot="{ hours, minutes, seconds }">
                          <b-badge variant="danger" style="white-space: nowrap; margin: 2px;">Delete in
                            {{ hours }}:{{ minutes }}:{{ seconds }}
                          </b-badge><b-link
                            @click="deletePoModel.id = po.id; $bvModal.show('cancelDeletePoConfirmationModel')">
                            <b-badge variant="success">Cancel Deletion</b-badge></b-link>
                        </vue-countdown>
                      </div>
                    </td>
                    <td>{{ po.outcome }}</td>
                    <td v-if="!course_id">
                      <span class="text-info btn m-0 p-0 sm" size="sm" @click="createEditPo(reindex)"
                        :disabled="actionButton.disabled"><i class="fas fa-pen ml-3"></i></span>
                      <span v-if="(enableDeletePoButton && po.deleted_at == null)" :id="'usergroupAdmin' + reIndex"
                        class="btn p-0 m-0 text-info" @click="openDeletePoModel(po.id, po.code)">
                        <i style="color:red;" class="fas fa-trash"></i>
                      </span>

                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </b-col>
        </b-row>
      </div>
      <div v-if="resourceaction == 'createEdit'">
        <div v-if="enableImport">
          <h3 style="text-align: center; font-size:18px !important;">
            Import PO From Xcel File
          </h3>
          <img src="../../assets/images/poExcelImport.jpeg" alt="" style="width: 90%;" class="img-fluid" />
          <p>Fill xcel file with serial number(first column) then PO Name(second column) and Outcome Description(third
            column).</p>
          <b-form-file class="mb-2" v-model="xcelImportFile" :state="Boolean(xcelImportFile)"
            accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, .csv"
            placeholder="Choose an xcel file or drop it here..." drop-placeholder="Drop file here..."
            @change="importPoFromXcel"></b-form-file>
          <div>
            <div v-for="importPo in importPOs" :key="importPo.code" class=" border border-success m-3 p-2">
              <b-row>
                <b-col sm="6">
                  <b-form-group id="input-group-1" label-for="input-1" description="">
                    <label class="required-label" for="">Si. No.:</label>
                    <b-form-input id="input-1" v-model="importPo.si_no" type="text"
                      placeholder="Enter a Number"></b-form-input>
                  </b-form-group>
                </b-col>
                <b-col sm="6">
                  <b-form-group id="input-group-2" label-for="input-2" description="">
                    <label class="required-label" for="">PO Name:</label>
                    <b-form-input id="input-2" v-model="importPo.code" type="text" placeholder="PO 1"></b-form-input>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <b-form-group id="input-group-1" label-for="input-1" description="">
                    <label class="required-label" for="">PO Description:</label>
                    <b-form-textarea v-model="importPo.outcome" placeholder="Description" rows="3"
                      max-rows="6"></b-form-textarea>
                  </b-form-group>
                </b-col>
              </b-row>
            </div>

            <b-row v-if="(importPOs.length > 0)">
              <b-col sm="12" style="text-align:right;">
                <b-button variant="success" class="text-white sm" size="sm" @click="createImportedPo"
                  :disabled="actionButton.disabled">{{ actionButton.text }}</b-button>
              </b-col>
            </b-row>
          </div>
        </div>
        <div v-else-if="enablePoCopy">
          <h3 style="text-align: center; font-size:18px !important;">
            Copy PO from other Programme
          </h3>
          <!-- this.pogroups  = {{ pogroups }} -->
          <b-form-group>
            <label class="required-label" for="">Choose Programme:</label>
            <b-form-select @change="getUsergroupPosForPoCopy" :options="copyPoUsergroups" v-model="copyPoUsergroup_id">
            </b-form-select>
            <span v-if="(copyPoUsergroups.length < 1)" class="text-danger">Loading...</span>
          </b-form-group>
          <ul v-if="copyPoUsergroup_id">
            <span class="text-danger" v-if="(copyFromPoIds.length < 1)">PO list is empty on selected
              programme</span>
            <!-- <li v-for="poOption in copyFromPoOptions" :key="poOption.id">
              <b-form-checkbox v-model="copyFromPoIds" name="checkbox-pocopyoption" :value="poOption.id">
                {{ poOption.code }}-{{ poOption.outcome }}
              </b-form-checkbox>
            </li> -->


            <div v-for="group in pogroups.groups" :key="group.id" class="border rounded p-2 mb-2">

              <!-- GROUP HEADER WITH RADIO -->
              <div class="d-flex align-items-center">
                <b-form-radio v-model="selectedPoGroupId" :value="group.id" @change="onPoGroupChange(group)"
                  class="mr-2" />
                <b><u>{{ group.name }}</u></b>
              </div>

              <!-- PO LIST (ALWAYS VISIBLE) -->
              <ul class="mt-2 pl-4">
                <li v-if="group.programme_outcomes.length < 1" class="text-danger">
                  PO list is empty
                </li>

                <li v-for="po in group.programme_outcomes" :key="po.id">
                  {{ po.code }} - {{ po.outcome }}
                </li>
              </ul>

            </div>


          </ul>
          <b-row>
            <b-col sm="12" style="text-align:right;">
              <b-button variant="success" class="text-white sm" size="sm" @click="submitCopyPo"
                :disabled="(copyFromPoIds.length < 1)">{{ actionButton.text }}</b-button>
            </b-col>
          </b-row>
        </div>
        <div v-else>
          <h3 style="text-align: center; font-size:18px !important;">
            {{ po.id ? 'Edit PO' : 'Add new PO' }}
          </h3>
          <b-row>
            <b-col sm="6">
              <b-form-group id="input-group-1" label-for="input-1" description="">
                <label class="required-label" for="">Si. No.:</label>
                <b-form-input id="input-1" v-model="po.si_no" type="text" placeholder="Enter a Number"></b-form-input>
              </b-form-group>
            </b-col>
            <b-col sm="6">
              <b-form-group id="input-group-2" label-for="input-2" description="">
                <label class="required-label" for="">PO Name:</label>
                <b-form-input id="input-2" v-model="po.code" type="text" placeholder="PO 1"></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-form-group id="input-group-1" label-for="input-1" description="">
                <label class="required-label" for="">PO Description:</label>
                <b-form-textarea v-model="po.outcome" placeholder="Description" rows="3" max-rows="6"></b-form-textarea>
              </b-form-group>
            </b-col>
          </b-row>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import { SOFT_DELETE_RETENTION_MINUTES } from "@/constants";
import moment from 'moment';
import VueCountdown from "@chenfengyuan/vue-countdown";
import readXlsxFile from "read-excel-file";
import axios from "axios";
export default {
  props: ['usergroup_id', 'po_group_id', 'course_id'],
  async created() {
    this.getPos();
  },
  components: {
    VueCountdown,
  },
  data() {
    return {
      otpSent: false,
      otp: "",
      otpVerified: false,
      showOtpBox: false,
      fetchData: false,
      resourceaction: "list", // list,createEdit
      deletePoModel: { id: null, name: null, confirmText: '', reason: '' },
      pos: [],
      pogroups: [],
      po: {
        id: null,
        si_no: '',
        name: "",
        code: '',
        outcome: "",
        usergroup_id: '',
      },
      actionButton: {
        text: "Save",
        disabled: false,
      },

      importPOs: [],
      enableImport: false,
      xcelImportFile: null,

      enablePoCopy: false,
      copyPoUsergroups: [],
      copyPoUsergroup_id: null,
      selectedPoGroupId: null,   // radio selection
      copyFromPoOptions: [],
      copyFromPoIds: [],
      enableDeletePoButton: true,
      deletedPo: {},
    };
  },
  methods: {
    async sendOtp() {
      if (
        confirm(
          'WARNING: You are going to delete "' +
          name +
          '".PO data will be deleted from all course lesson plan, CO-PO/PSO mapping, activity, end semester exam data, and all program exit and stakeholder survey questions. Do you still want to proceed?'
        ) == true
      ) {

        this.showOtpBox = true;
        const url =
          this.$store.getters.getAPIKey.mainAPI + `/programmeoutcomes/send-delete-otp`;

        await this.$axios.post(url, {
          po_id: this.deletePoModel.id
        })
          .then(() => {
            // this.$toast.success("OTP sent to your registered email", {
            //   position: "top",
            //   duration: 5000,
            // });
          })
          .catch(() => {
            this.$toast.error("Failed to send OTP", {
              position: "top",
              duration: 5000,
            });
          });
      }
    },

    async verifyOtp() {
      const url =
        this.$store.getters.getAPIKey.mainAPI + `/programmeoutcomes/verify-delete-otp`;

      await this.$axios.post(url, {
        otp: this.otp,
        po_id: this.deletePoModel.id
      })
        .then(() => {
          // this.$toast.success("OTP verified successfully", {
          //   position: "top",
          //   duration: 4000,
          // });

          this.otpVerified = true;
          this.otp = null;
          this.showOtpBox = false;

          this.deletePo();
        })
        .catch(() => {
          this.$toast.error("Invalid OTP", {
            position: "top",
            duration: 5000,
          });
        });
    },
    async CancelDeletion() {
      const url =
        this.$store.getters.getAPIKey.mainAPI + `/programmeoutcomes/${this.deletePoModel.id}/canceldeletion`;
      this.$axios
        .post(url, { reason: this.deletePoModel.reason })
        .then(() => {
          this.deletePoModel = { id: null, name: null, confirmText: '', reason: '' };
          this.otp = null;
          this.showOtpBox = false;
          this.getPos();
        });
    },
    timeToDeleteIn(deleted_at) {
      // Step 1: Add the deletion window to the API response time
      const futureTime = moment.utc(deleted_at, 'YYYY-MM-DD HH:mm:ss').add(SOFT_DELETE_RETENTION_MINUTES, 'minutes');

      // Step 2: Get the current UTC time using moment.js
      const currentUTCTime = moment.utc();
      // Step 3: Calculate the difference in seconds
      const timeDifferenceInSeconds = futureTime.diff(currentUTCTime, 'seconds');
      return timeDifferenceInSeconds * 1000;
    },
    deletePo() {
      let id = this.deletePoModel.id;
      let name = this.deletePoModel.name;
      this.enableDeletePoButton = false;
      this.deletedPo.id = id;
      this.deletedPo.name = name;
      // if (
      //   confirm(
      //     'WARNING: You are going to delete "' +
      //     name +
      //     '".PO data will be deleted from all course lesson plan, CO-PO/PSO mapping, activity, end semester exam data, and all program exit and stakeholder survey questions. Do you still want to proceed?'
      //   ) == true
      // ) {
      const url =
        this.$store.getters.getAPIKey.mainAPI + `/programmeoutcomes/${id}`;
      this.$axios
        .delete(url, {
          data: { reason: this.deletePoModel.reason },
        })
        .then(() => {
          // console.log(response)
          this.$toast.success(`${name} deletion initiated successfully`, {
            position: "top-right",
            duration: 6000,
          });
          this.enableDeletePoButton = true;

          this.deletePoModel = { id: null, name: null, confirmText: '', reason: '' };
          //this.$emit("GroupCreated", true);
          this.getPos();
        })
        .catch((error) => {
          // console.log(error);
          this.$toast.error(
            `${name} is failed to delete, ` + error.response.data.message,
            {
              position: "top-right",
              duration: 6000,
            }
          );
          error;
          this.enableDeletePoButton = true;
        });
      // } else {
      //   this.enableDeletePoButton = true;
      // }
    },

    openDeletePoModel(id, name) {
      this.deletePoModel = { id: id, name: name, confirmText: '', reason: '' };
      this.$bvModal.show("deletePoConfirmationModel");
    },

    async submitCopyPo() {
      this.fetchData = true;
      this.actionButton = {
        text: "Saving...",
        disabled: true,
      };
      let url = this.$store.getters.getAPIKey.mainAPI + `/programmeoutcomes/copy`;

      await axios.post(url, {
        programme_outcomes: this.copyFromPoIds,
        copy_to_usergroup: this.usergroup_id,
        po_group_id: this.po_group_id
      })
        .then(() => {
          this.$toast.success("PO copied successfully", {
            position: "top",
            duration: 3000,
          });
          this.getPos();
        })
        .catch(() => {
          let errortxt = "Failed to Copy PO";
          this.$toast.error(errortxt, {
            position: "top",
            duration: 7000,
          });
          return;
        });

      this.fetchData = false;
      this.actionButton = {
        text: "Save",
        disabled: false,
      };
    },
    async getCopyPoOptions() {
      this.copyFromPoOptions = [];
      this.copyFromPoIds = [];
      this.copyPoUsergroups = [];
      this.copyPoUsergroup_id = null;
      this.enablePoCopy = true;
      const url =
        this.$store.getters.getAPIKey.mainAPI +
        `/usergroups?allusergroups=1`;
      await this.$axios
        .get(url)
        .then((response) => {
          response.data.forEach(group => {
            this.copyPoUsergroups.push({
              value: group.id, text: `${group.code}-${group.name}-${group.scheme}-${group.affiliated_university}`
            });
          });
        })
        .catch((error) => {
          error;
        });

      this.actionButton.text = 'Start Copy';
    },

    async getUsergroupPosForPoCopy() {
      this.fetchData = true;
      this.copyFromPoOptions = [];
      this.copyFromPoIds = [];
      const url =
        this.$store.getters.getAPIKey.mainAPI +
        `/po-groups?usergroup_id=${this.copyPoUsergroup_id}`;
      await this.$axios
        .get(url)

        .then((response) => {
          this.pogroups = response.data;

          if (this.pogroups.groups.length > 0) {
            const firstGroup = this.pogroups.groups[0];

            this.selectedPoGroupId = firstGroup.id;

            // auto select all POs under 1st group
            this.copyFromPoIds = [];
            firstGroup.programme_outcomes.forEach(po => {
              this.copyFromPoIds.push(po.id);
            });
          }
        })

        .catch((error) => {
          error;
        });
      this.fetchData = false;
    },

    onPoGroupChange(group) {
      this.selectedPoGroupId = group.id;

      // clear old selection
      this.copyFromPoIds = [];

      // auto select all POs under selected group
      group.programme_outcomes.forEach(po => {
        this.copyFromPoIds.push(po.id);
      });
    },

    async createImportedPo() {
      this.fetchData = true;
      this.actionButton = {
        text: "Saving...",
        disabled: true,
      };
      let url = this.$store.getters.getAPIKey.mainAPI + `/programmeoutcomes`;
      let failedImportPOs = [];
      for (let index = 0; index < this.importPOs.length; index++) {
        const po = this.importPOs[index];
        await axios.post(url, po)
          .then(() => {
            this.$toast.success(po.code + " created successfully", {
              position: "top",
              duration: 3000,
            });
          })
          .catch((error) => {
            failedImportPOs.push(po);
            let errortxt = "";
            if (error.response)
              if (error.response.status == 422) {
                let errormsgs = error.response.data.errors;
                for (const key in errormsgs) {
                  errortxt = errormsgs[key][0];
                }
              } else {
                errortxt = error.response.data.message;
              }
            else {
              errortxt = "Failed to Update/Create";
            }
            this.$toast.error(errortxt, {
              position: "top",
              duration: 7000,
            });
            return;
          });
      }

      this.fetchData = false;
      this.actionButton = {
        text: "Save",
        disabled: false,
      };
      if (failedImportPOs.length < 1) this.getPos();
      this.importPOs = failedImportPOs;
    },
    async importPoFromXcel(e) {
      if (e.target.files[0] == null) return;

      let error = false;
      let xcelSheet = null;
      await readXlsxFile(e.target.files[0]).then((sheet) => {
        xcelSheet = sheet;
      }).catch(() => {
        this.$toast.error('Failed to process the input xcel file', {
          position: "top",
          duration: 6000,
        });
        error = true;
      });
      if (xcelSheet.length < 1) {
        this.$toast.error('Excel has empty, please fill it.', {
          position: "top",
          duration: 6000,
        });
        error = true;
      }
      if (error) return;
      console.log();
      await xcelSheet.forEach((sheetRow, rowIndex) => {
        if (sheetRow.length != 3) {
          this.$toast.error('Number of column in each row should be 3. Row ' + (rowIndex + 1) + ' has more or less column used', {
            position: "top",
            duration: 6000,
          });
          error = true;
        } else {
          this.importPOs.push({
            si_no: sheetRow[0],
            code: sheetRow[1],
            outcome: sheetRow[2],
            usergroup_id: this.usergroup_id,
            po_group_id: this.po_group_id
          });
        }
      });
      if (this.importPOs.length > 0) this.$toast.warning(this.importPOs.length + ' POs are imported from excel, please verify and submit', {
        position: "top",
        duration: 6000,
      });
      this.xcelImportFile = null;
    },
    async createEditPo(index) {
      this.enableImport = false;
      this.enablePoCopy = false;
      this.importPOs = [];

      this.po = {
        id: null,
        si_no: this.pos.length + 1,
        name: "",
        code: '',
        outcome: "",
        usergroup_id: this.usergroup_id,
        po_group_id: this.po_group_id
      };
      if (index !== null) this.po = this.pos[index];

      this.resourceaction = 'createEdit';
    },
    async getPos() {
      this.fetchData = true;
      this.resourceaction = 'list';
      const url =
        this.$store.getters.getAPIKey.mainAPI +
        `/programmeoutcomes?usergroup=${this.usergroup_id}&po_group_id=${this.po_group_id}`;
      await this.$axios
        .get(url)
        .then((response) => {
          this.pos = response.data;
        })
        .catch((error) => {
          error;
        });
      this.fetchData = false;
      this.$emit('refresh-groups');
    },
    async createUpdatePo() {
      this.fetchData = true;
      this.actionButton = {
        text: "Saving...",
        disabled: true,
      };
      let url = this.$store.getters.getAPIKey.mainAPI + `/programmeoutcomes`;
      let action = 'post';
      if (this.po.id) {
        url += `/${this.po.id}`;
        action = 'put';
      }

      await axios[action](url, this.po)
        .then(() => {
          this.$toast.success("PO created successfully", {
            position: "top",
            duration: 3000,
          });
          this.getPos();
        })
        .catch((error) => {
          let errortxt = "";
          if (error.response)
            if (error.response.status == 422) {
              let errormsgs = error.response.data.errors;
              for (const key in errormsgs) {
                errortxt = errormsgs[key][0];
              }
            } else {
              errortxt = error.response.data.message;
            }
          else {
            errortxt = "Failed to Update/Create";
          }
          this.$toast.error(errortxt, {
            position: "top",
            duration: 7000,
          });
          return;
        });

      this.fetchData = false;
      this.actionButton = {
        text: "Save",
        disabled: false,
      };
    },
    
  },
};
</script>

<style>
.disable-wrapper.disabled {
  background-color: #e0e0e0;
  /* gray */
  pointer-events: none;
  /* disable all */
  opacity: 0.7;
}

.tag-button button {
  font-size: 9px !important;
  padding: 3px;
}
</style>
